import { axios, handleApiError } from "./Api";

const InvoicesApi = {
  /**
   * Get Invoices for client
   */
  async getInvoices(startDate, endDate) {
    //set start date limit to fetch invoices
    return axios
      .get(axios.defaults.baseURL + "/invoices/client?startDate=" + startDate.format('YYYY-MM-DD') + "&endDate=" + endDate.format('YYYY-MM-DD'))
      .then(response => {
        return response.data.invoices;
      })
      .catch(handleApiError);
  }
};

export default InvoicesApi;
